<template>
  <div class="settings-stun-servers">
    <div class="stun-servers ma-2">
      <stun-servers />
    </div>
  </div>
</template>

<script>
import StunServers from '@/components/settings/stun_servers'

export default {
  name: 'settings-stun-servers',
  components: {
    StunServers
  }
}
</script>

<style></style>
